












































import { defineComponent } from '@vue/composition-api'

// components
import { Select2, DatePicker } from '@/components/general'

// hooks
import useEmployeesOp from '@/hooks/useEmployeesOp'

export default defineComponent({
  name: 'FiltersLunchControl',
  components: {
    Select2,
    DatePicker
  },
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  setup () {
    const { employeesOp } = useEmployeesOp()

    return {
      employeesOp
    }
  }
})
